<script setup lang="ts">
import { type DropdownDividerOption, type DropdownGroupOption, type DropdownOption, type DropdownRenderOption, NDropdown } from 'naive-ui'
import { useAttrs } from 'vue'

// interface DropdownOption {
//   label: string
//   key: string | number
//   disabled?: boolean
//   icon?: any
//   children?: DropdownOption[]
//   [key: string]: any
// }

const props = withDefaults(defineProps<{
  options?: Array<DropdownOption | DropdownGroupOption | DropdownDividerOption | DropdownRenderOption>
  trigger?: 'click' | 'hover' | 'contextmenu'
  placement?: 'top' | 'top-start' | 'top-end' | 'right' | 'right-start' | 'right-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end'
  delay?: number
  duration?: number
  disabled?: boolean
  showArrow?: boolean
  arrowPointToCenter?: boolean
  keepAliveOnHover?: boolean
  flip?: boolean
  shift?: boolean
  resize?: boolean
  width?: number | string
  maxWidth?: number | string
  minWidth?: number | string
  to?: string | HTMLElement
  displayDirective?: 'if' | 'show'
  zIndex?: number
  overlap?: boolean
  offset?: number
  animated?: boolean
  animationDuration?: number
  onSelect?: (key: string | number, option: DropdownOption) => void
  onUpdateShow?: (show: boolean) => void
  onAfterEnter?: () => void
  onAfterLeave?: () => void
}>(), {
  options: () => [],
  trigger: 'click',
  placement: 'bottom',
  delay: 100,
  duration: 200,
  disabled: false,
  showArrow: true,
  arrowPointToCenter: false,
  keepAliveOnHover: true,
  flip: true,
  shift: true,
  resize: true,
  width: undefined,
  maxWidth: undefined,
  minWidth: undefined,
  to: undefined,
  displayDirective: 'if',
  zIndex: undefined,
  overlap: false,
  offset: 12,
  animated: true,
  animationDuration: 150,
})

const emit = defineEmits<{
  'select': [key: string | number, option: DropdownOption]
  'update:show': [show: boolean]
  'after-enter': []
  'after-leave': []
}>()

const attrs = useAttrs()

const onSelect = (key: string | number, option: DropdownOption) => {
  emit('select', key, option)
}

const onUpdateShow = (show: boolean) => {
  emit('update:show', show)
}

const onAfterEnter = () => {
  emit('after-enter')
}

const onAfterLeave = () => {
  emit('after-leave')
}
</script>

<template>
  <NDropdown
    :options="options"
    :trigger="trigger as 'click' | 'hover' | 'focus' | 'manual'"
    :placement="placement"
    :delay="delay"
    :duration="duration"
    :disabled="disabled"
    :show-arrow="showArrow"
    :arrow-point-to-center="arrowPointToCenter"
    :keep-alive-on-hover="keepAliveOnHover"
    :flip="flip"
    :shift="shift"
    :resize="resize"
    :width="width as number | 'trigger'"
    :max-width="maxWidth as number"
    :min-width="minWidth as number"
    :to="to"
    :display-directive="displayDirective"
    :z-index="zIndex"
    :overlap="overlap"
    :offset="offset"
    :animated="animated"
    :animation-duration="animationDuration"
    v-bind="attrs"
    @select="onSelect as (key: string | number, option: DropdownOption) => void"
    @update:show="onUpdateShow"
    @after-enter="onAfterEnter"
    @after-leave="onAfterLeave"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #default>
      <slot />
    </template>
  </NDropdown>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
